import ProductsSlider, { SliderDirection } from './productsSlider'
import { SwiperSlide } from 'swiper/react'
import HorizontalTitledProductsSlider from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'

const ProductSlide = SwiperSlide

export { HorizontalTitledProductsSlider, SliderDirection, ProductSlide }
export default ProductsSlider
